import { Injectable } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { ValidationLogic } from './validation-logic';

@Injectable()
export abstract class CustomBaseNumberPipe {

    public abstract transform(value: any): string;

    protected abstract isValidNumberFormat(control: AbstractControl, allowNegative?: boolean): boolean;

    protected isFormattableNumber(value: any, allowNegative: boolean): boolean {
        // use an abstract control so we can use our already-proven validation logic.
        let control: FormControl = new FormControl(value);

        // see if we can parse the value to a number.
        if (ValidationLogic.isNullOrWhiteSpace(control)) {
            return true;
        }

        // the number can be formatted if it matches the number format.
        return this.isValidNumberFormat(control, allowNegative);
    }

    protected formatNumericValue(value: number, decimalPlaces: number): string {
        let control: FormControl = new FormControl(value);

        if (ValidationLogic.isNullOrWhiteSpace(control)) {
            // if null or empty, return blank
            return '';
        }

        // verify decimal places is a number
        if (decimalPlaces && !ValidationLogic.isInteger(new FormControl(decimalPlaces), false)) {
            throw 'decimalPlaces is not a valid whole number.';
        }
        else if (!decimalPlaces) {
            // default to zero decimal places if the value was not passed in.
            decimalPlaces = 0;
        }

        // 'toFixed(2)' forces two decimal places.  The replace call will add in commas in the thousands place, etc.
        let stringValue: string = Number(value).toFixed(decimalPlaces);

        // default the base value to the full string value.
        let baseValue: string = stringValue;
        let decimalValue: string = '';
        let decimalPointIndex: number = stringValue.indexOf('.');

        if (decimalPointIndex > -1) {
            // if a decimal point exists, we'll only add commas to the numbers on the right of the decimal point.
            //  store the decimal portion in a separate variable.
            baseValue = stringValue.substring(0, decimalPointIndex);
            decimalValue = stringValue.substring(decimalPointIndex);
        }

        baseValue = baseValue.replace(/\B(?=(\d{3})+(?!\d))/gi, ',');

        // append base value + decimal value.
        let displayValue: string = `${baseValue}${decimalValue}`;

        return displayValue;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/custom-base-number.pipe.ts